var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 33.5,
    height: 33.5,
    rx: 16.75,
    fill: "#2F75DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87402 10.2883C9.51372 10.6486 9.51372 11.2327 9.87402 11.593L15.4969 17.2159L9.87373 22.839C9.51344 23.1993 9.51344 23.7834 9.87374 24.1437C10.234 24.504 10.8182 24.504 11.1785 24.1437L16.8016 18.5206L22.4246 24.1436C22.7849 24.5039 23.369 24.5039 23.7293 24.1436C24.0896 23.7833 24.0896 23.1991 23.7293 22.8389L18.1063 17.2159L23.729 11.5932C24.0893 11.2329 24.0893 10.6487 23.729 10.2884C23.3687 9.92813 22.7846 9.92813 22.4243 10.2884L16.8016 15.9111L11.1788 10.2883C10.8185 9.92799 10.2343 9.92799 9.87402 10.2883Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.87d0a2fa682fd239e0cb0f781b597a55.svg";
export { ForwardRef as ReactComponent };